export class Email {
  constructor() {
    this.id = 0;
    this.enderecoEmail = '';
  }
}
